<template v-if="consumerunit">
  <v-flex md12>
    <material-card color="cyan" title="Dados da Unidade Consumidora" text="">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container py-0>
          <v-layout wrap>
            <v-flex xs12 md-auto class="pb-0">
              <v-chip
                v-if="type === 'edit'"
                small
                dark
                :color="consumerunit.status | formatUCStatusColor"
                >{{ consumerunit.status || "-" | formatUCStatus }}</v-chip
              >
              <v-chip v-else small dark color="blue">Nova</v-chip>
            </v-flex>
            <v-flex xs12 md2>
              <v-radio-group
                v-model="consumerunit.person_type"
                :rules="[(v) => !!v || 'Por favor, informe o Tipo de Pessoa!']"
                :hint="'Informe o Tipo de Pessoa'"
                row
                :readonly="all_readonly"
              >
                <v-radio label="Pessoa Física" value="pf"></v-radio>
                <v-radio label="Pessoa Jurídica" value="pj"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                id="customer_cpf"
                v-model.trim="consumerunit.cpf"
                :rules="notEmptyRule"
                label="*CPF/CNPJ"
                return-masked-value
                :v-mask="['###.###.###-##', '##.###.###/####-##']"
                required
                :readonly="all_readonly"
                ref="cpfField"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md2>
              <v-autocomplete
                label="Empresa*"
                :items="companies"
                v-model="consumerunit.company"
                :rules="notEmptyRule"
                required
                :readonly="all_readonly"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 md3>
              <v-autocomplete
                label="Concessionária*"
                :items="utilityCompanies"
                item-value="id"
                item-text="name"
                v-model="consumerunit.utility_company"
                required
                :readonly="all_readonly"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 md2 text-xs-right>
              <cpn-customer-upload
                v-if="type === 'new'"
                :key="customerUploadKey"
                :utility_company="consumerunit.utility_company"
                :disabled="all_readonly"
                :user_id="user_id"
              />
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                id="consumerunit_name"
                ref="name"
                :rules="notEmptyRule"
                v-model="consumerunit.name"
                name="name"
                label="*Nome Completo"
                prepend-icon="person"
                required
                :readonly="all_readonly"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                id="consumerunit_postal_code"
                v-model="consumerunit.address.postal_code"
                name="postal_code"
                label="*CEP"
                required
                :rules="[
                  (v) => !!v || 'Por favor, informe o CEP do membro',
                  (v) =>
                    v.length > 7 || 'Ops. Parece que esse não é um CEP válido',
                ]"
                @change="buscaCep($event)"
                :readonly="all_readonly"
              >
                <template v-slot:append>
                  <v-fade-transition leave-absolute>
                    <v-progress-circular
                      v-if="loading_cep"
                      size="24"
                      color="info"
                      indeterminate
                    >
                    </v-progress-circular>
                  </v-fade-transition>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                id="consumerunit_address"
                v-model="consumerunit.address.address"
                name="address"
                label="*Endereço Completo"
                required
                :rules="[
                  (v) => !!v || 'Por favor, informe o endereço do membro',
                ]"
                :readonly="all_readonly"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                id="consumerunit_address_number"
                v-model="consumerunit.address.address_number"
                name="address_number"
                label="*Número"
                required
                :rules="[
                  (v) =>
                    !!v || 'Por favor, informe o número do endereço do membro',
                ]"
                :readonly="all_readonly"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                v-model="consumerunit.address.address_complement"
                name="address_complement"
                label="Complemento"
                :readonly="all_readonly"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                id="consumerunit_district"
                v-model="consumerunit.address.district"
                name="district"
                label="*Bairro"
                prepend-icon="maps_home_work"
                required
                :readonly="all_readonly"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                id="consumerunit_city"
                v-model="consumerunit.address.city"
                name="city"
                label="*Cidade"
                prepend-icon="location_city"
                required
                :readonly="all_readonly"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md3>
              <v-autocomplete
                :items="states"
                item-text="name"
                item-value="initials"
                label="Estado"
                prepend-icon="map"
                v-model="consumerunit.address.state"
                return-object
                :rules="[(v) => !!v || 'Por favor, selecione o seu estado!']"
                :hint="'Selecione o estado'"
                required
                :readonly="all_readonly"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 md3>
              <v-autocomplete
                :items="plansList"
                item-text="name"
                label="Plano"
                v-model.lazy="plan"
                :rules="notEmptyRule"
                required
                return-object
                ref="ucPlan"
                :readonly="all_readonly"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 md2>
              <v-text-field
                id="customer_number"
                :rules="customerNumberRule"
                v-model.trim="consumerunit.customer_number"
                :label="customer_number_formatted"
                :readonly="all_readonly"
                type="number"
                @keydown="preventNumberChange"
              >
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        color="purple"
                        size="16"
                        v-on="on"
                        icon
                        style="cursor: default"
                        class="mr-1"
                        >mdi-alert-circle-outline</v-icon
                      >
                    </template>
                    <div>
                      <p class="font-weight-bold">
                        Atenção! O preenchimento incorreto deste campo pode
                        causar problemas na alocação do cliente.
                      </p>
                    </div>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                id="installation_number"
                v-model.trim="consumerunit.installation_number"
                label="Número de Instalação"
                type="number"
                :rules="installationNumberRule"
                required
                @change="validaUnidadeConsumidora($event)"
                :readonly="
                  all_readonly || (type == 'edit' && !permissions.change_uc_id)
                "
                @keydown="preventNumberChange"
              >
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        color="purple"
                        size="16"
                        v-on="on"
                        icon
                        style="cursor: default"
                        class="icon_position"
                        >mdi-alert-circle-outline</v-icon
                      >
                    </template>
                    <div>
                      <p class="font-weight-bold">
                        Atenção! O preenchimento incorreto deste campo pode
                        causar problemas na alocação do cliente.
                      </p>
                    </div>
                  </v-tooltip>
                </template></v-text-field
              >
            </v-flex>
            <v-flex xs12 md3>
              <v-combobox
                id="rate_class"
                v-model="consumerunit.rate_class"
                :items="rate_classes"
                label="Classe"
                required
                :rules="[
                  (v) => !!v || 'Por favor, selecione a classe da instalação!',
                ]"
                :readonly="all_readonly"
              ></v-combobox>
            </v-flex>
            <v-flex xs12 md3>
              <v-combobox
                id="subclass"
                v-model="consumerunit.sub_class"
                label="Sub Classe"
                required
                item-text="subclass"
                item-value="subclass"
                :items="subclasses"
                :rules="[
                  (v) =>
                    !!v || 'Por favor, selecione a sub classe da instalação!',
                ]"
                :readonly="all_readonly"
              ></v-combobox>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                id="tarifa"
                v-model.number="consumerunit.fare_amount"
                label="Tarifa Base"
                type="number"
                :rules="notEmptyRule"
                :hint="
                  consumerunit.fare_amount < 0.7
                    ? 'ATENÇÃO! Tarifa menor que 0,70 apenas com aprovação da diretoria.'
                    : ''
                "
                required
                :readonly="all_readonly"
                @keydown="preventNumberChange"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm12
              md12
              style="display: flex; flex-direction: column"
              v-if="consumerunit.history"
            >
              <p class="font-weight-bold">Histórico de consumo</p>
              <v-layout row wrap v-if="consumerunit.history" class="px-1">
                <v-flex
                  xs12
                  sm6
                  md3
                  v-for="(history, index) in consumerunit.history.slice(0, 4)"
                  :key="index"
                >
                  <p>Mês {{ index + 1 }}</p>
                  <v-text-field
                    v-model.number="history.consumo"
                    type="number"
                    prefix="kWh"
                    :rules="[
                      (v) => !!v || 'Por favor, insira o valor do consumo',
                    ]"
                    required
                    :readonly="all_readonly"
                    class="pt-0"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 class="py-0">
                  <p v-if="history_alert_message" class="history_alert">
                    <v-icon size="20" color="orange" class="icon"
                      >mdi-alert-circle-outline</v-icon
                    >
                    {{ history_alert_message }}
                  </p>
                  <p v-else style="color: #777777">
                    * Preencher o histórico de consumo dos últimos 4 meses.
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex v-if="type === 'edit'" xs12 md6>
              <v-layout v-if="isAdmin" wrap>
                <v-flex xs12 md4>
                  <v-tooltip bottom :disabled="!user.available_discounts">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        id="discount"
                        :rules="notEmptyRule"
                        type="number"
                        v-model.number="consumerunit.percentage_discount"
                        label="% de Desconto"
                        required
                      ></v-text-field>
                    </template>
                    <span
                      >Desconto desse membro é definido por método de pagamento.
                      Tenha certeza caso deseje alterar este valor!</span
                    >
                  </v-tooltip>
                </v-flex>
                <v-flex xs12 md8>
                  <v-autocomplete
                    id="power_plant"
                    :items="power_plants"
                    value="name"
                    item-text="name"
                    item-value="power_plant_id"
                    prepend-icon="flash_on"
                    label="Planta"
                    name="power_plant"
                    return-object
                    v-model="consumerunit.powerplant"
                    :rules="[
                      (v) => !!v || 'Selecione a Planta que o User irá entrar',
                    ]"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs10 md10>
                  <v-text-field
                    id="contract_id"
                    type="text"
                    v-model.lazy="consumerunit.contract_id"
                    label="ID do Contrato"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 md2>
                  <v-tooltip bottom v-if="consumerunit.contract_id">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="mx-0 font-weight-light"
                        color="success"
                        :loading="loading"
                        :disabled="!valid || loading"
                        :href="
                          'https://painel.autentique.com.br/documentos/' +
                          consumerunit.contract_id
                        "
                        target="_blank"
                        small
                        flat
                        v-on="on"
                      >
                        <v-icon left dark>grading</v-icon>
                      </v-btn>
                    </template>
                    <span>Ver Contrato</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex v-else xs12 md6>
              <v-flex>
                Altere os parâmetros a seguir somente se necessário.
              </v-flex>
              <v-flex>
                <v-layout align-center>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-checkbox
                        v-on="on"
                        hide-details
                        class="shrink mr-2"
                        v-model="custom_percentage_discount_enable"
                      ></v-checkbox>
                    </template>
                    <span
                      >Atenção! Tenha certeza que deseja fazer essa
                      mudança.</span
                    >
                  </v-tooltip>
                  <v-text-field
                    type="number"
                    v-model="custom_percentage_discount"
                    label="% de Desconto"
                    :disabled="!custom_percentage_discount_enable"
                    :readonly="!custom_percentage_discount_enable"
                  ></v-text-field>
                </v-layout>
              </v-flex>
              <v-flex v-if="user?.payment_type === 'boleto'">
                <v-layout align-center>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-checkbox
                        v-on="on"
                        hide-details
                        class="shrink mr-2"
                        v-model="custom_unique_billing_enable"
                      ></v-checkbox>
                    </template>
                    <span
                      >Atenção! Tenha certeza que deseja fazer essa
                      mudança.</span
                    >
                  </v-tooltip>
                  <v-select
                    v-model="custom_unique_billing"
                    label="Conta única"
                    required
                    :items="[
                      { text: 'Sim', value: true },
                      { text: 'Não', value: false },
                    ]"
                    item-text="text"
                    item-value="value"
                    :disabled="!custom_unique_billing_enable"
                    :readonly="!custom_unique_billing_enable"
                  ></v-select>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout align-center>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-checkbox
                        v-on="on"
                        hide-details
                        class="shrink mr-2"
                        v-model="custom_power_plant_enable"
                      ></v-checkbox>
                    </template>
                    <span
                      >Atenção! Tenha certeza que deseja fazer essa
                      mudança.</span
                    >
                  </v-tooltip>
                  <v-autocomplete
                    :items="power_plants"
                    value="name"
                    item-text="name"
                    item-value="power_plant_id"
                    label="Planta"
                    name="power_plant"
                    v-model="custom_power_plant"
                    :disabled="!custom_power_plant_enable"
                    :readonly="!custom_power_plant_enable"
                  ></v-autocomplete>
                </v-layout>
              </v-flex>
            </v-flex>
            <v-flex xs12 md6>
              <v-subheader class="grey lighten-3">Qualificação</v-subheader>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-checkbox
                    v-model="verify_rules"
                    label="Verificar regras de qualificação"
                    v-on="on"
                    :readonly="!isAdmin && !isQualityManagement"
                  ></v-checkbox>
                </template>
                <span
                  >Irá desqualificar caso as regras (tarifa, consumo, etc.) não
                  sejam cumpridas</span
                >
              </v-tooltip>
              <v-btn
                class="mx-2 font-weight-light"
                color="success"
                :loading="loading_init_qualification"
                :disabled="!valid || loading"
                @click.prevent="createQualification"
              >
                <v-icon left dark>rule</v-icon>
                Iniciar Qualificação
              </v-btn>
              <v-flex
                v-if="currentQualification && currentQualification.length > 0"
              >
                <v-list three-line>
                  <template
                    v-for="(qualification, idx) in currentQualification"
                  >
                    <qualifying-card
                      :key="idx"
                      :qualification="qualification"
                      v-if="qualification.status === 'pending'"
                    />
                    <not-qualified-card
                      :key="idx"
                      :qualification="qualification"
                      v-if="
                        qualification.status === 'bill_not_found' ||
                        qualification.status === 'error'
                      "
                    />
                    <disqualified-card
                      :key="idx"
                      :qualification="qualification"
                      v-if="qualification.status === 'disqualified'"
                    />
                    <qualified-card
                      :key="idx"
                      :qualification="qualification"
                      v-if="qualification.status === 'qualified'"
                    />
                  </template>
                </v-list>
              </v-flex>
              <v-flex text-xs-right>
                <v-textarea
                  v-if="type === 'edit'"
                  outline
                  v-model="motivo"
                  name="motivo"
                  label="Motivo da Alteração"
                  :rules="[
                    (v) =>
                      !!v ||
                      'Informe o motivo da alteração na unidade consumidora.',
                  ]"
                  value=""
                  required
                ></v-textarea>
                <v-btn
                  v-if="consumerunit.plan && permissions.change_plan_uc"
                  class="mx-2 font-weight-light"
                  color="success"
                  @click.prevent="changePlan"
                >
                  <v-icon left dark>mdi-sale</v-icon>
                  Alterar Plano
                </v-btn>
                <v-tooltip bottom v-if="type === 'edit'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mx-2 font-weight-light"
                      color="success"
                      :loading="loading"
                      :disabled="!valid || loading"
                      @click.prevent="storeconsumerunit(user_id, consumerunit)"
                      v-on="on"
                    >
                      <v-icon left dark>add</v-icon>
                      Salvar
                    </v-btn>
                  </template>
                  <span>Execute apenas após qualificar.</span>
                </v-tooltip>
                <v-btn
                  v-else
                  class="mx-2 font-weight-light"
                  color="success"
                  :loading="loading_finish_qualification"
                  :disabled="
                    !currentQualification ||
                    currentQualification.length < 1 ||
                    currentQualification[0].status !== 'qualified' ||
                    loading ||
                    loading_init_qualification ||
                    !allow_finish_qualification
                  "
                  @click.prevent="endQualification"
                >
                  <v-icon left dark>add</v-icon>
                  Salvar
                </v-btn>
                <v-tooltip bottom v-if="type === 'edit'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mx-2 font-weight-light"
                      color="green"
                      :loading="loading"
                      :disabled="
                        !valid ||
                        loading ||
                        (consumerunit.status === 'activated' &&
                          !permissions.generate_contract)
                      "
                      @click.prevent="createContract(user, consumerunit)"
                      v-on="on"
                    >
                      <v-icon left dark>note_add</v-icon>
                      Gerar Contrato
                    </v-btn>
                  </template>
                  <span>Execute apenas após salvar.</span>
                </v-tooltip>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </material-card>
    <v-snackbar
      :color="snack.color"
      :bottom="snack.bottom"
      :top="snack.top"
      :left="snack.left"
      :right="snack.right"
      v-model="snack.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.snackMessage }}</div>
      <v-icon size="16" @click="snack.snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>
    <ChangeUcPlanModal
      ref="changeUcPlan"
      :consumer_unit="consumerunit"
      :user="user"
      @showSnack="showSnack"
    ></ChangeUcPlanModal>
  </v-flex>
</template>

<script>
import statesfile from "@/model/state";
import firebase from "firebase";
import moment from "moment";
import { mask } from "vue-the-mask";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import firestore from "../../firebase/firestore";
import { eventBus } from "../../main";
import { getConsumerUnit } from "../../services/consumer_units";
import { getPowerPlants } from "../../services/firebase/powerplants";
import { getCEP } from "../../services/getCep";
import { getPermission } from "../../services/permissions";
import {
  calcQualification,
  finishQualification,
  initQualificationByForm,
} from "../../services/qualification";
import { saveAnalytics } from "../../services/save_analytics";
import { validaCNPJ, validaCPF } from "../../services/users";
import DisqualifiedCard from "../sales/qualification/DisqualifiedCard.vue";
import NotQualifiedCard from "../sales/qualification/NotQualifiedCard.vue";
import QualifiedCard from "../sales/qualification/QualifiedCard.vue";
import QualifyingCard from "../sales/qualification/QualifyingCard.vue";
import ChangeUcPlanModal from "./ChangeUcPlanModal.vue";
import CustomerUpload from "./CustomerUpload.vue";

export default {
  components: {
    cpnCustomerUpload: CustomerUpload,
    QualifiedCard,
    DisqualifiedCard,
    QualifyingCard,
    NotQualifiedCard,
    ChangeUcPlanModal,
  },
  data: function () {
    return {
      dialog_qualify: false,
      emailRules: [],
      user: {},
      user_id: null,
      rules: [],
      states: statesfile.estados,
      rate_classes: ["Monofásico", "Bifásico", "Trifásico"],
      motivo: "",
      sub_classes: [
        "Comercial",
        "Outros Serviços e Outras Ativ",
        "Residencial",
      ],
      status_list: [
        {
          label: "Ativo",
          value: "activated",
        },
        {
          label: "Cancelando",
          value: "canceling",
        },
        {
          label: "Cancelado",
          value: "canceled",
        },
        {
          label: "Pendente",
          value: "pending",
        },
        {
          label: "Aguardando assinatura",
          value: "awaiting_signature",
        },
        {
          label: "Gerando Contrato",
          value: "awaiting_contract_generation",
        },
        {
          label: "Aguardando revisão de documentos",
          value: "awaiting_review_documents",
        },
      ],
      companies: [
        {
          text: "Elétron",
          value: "eletron",
        },
        {
          text: "Juntos",
          value: "juntos",
        },
      ],
      consumerunit: {
        id: "",
        installation_number: "",
        customer_number: "",
        power_plant_id: "",
        percentage: 0,
        percentage_discount: 10,
        fare_amount: 0.95,
        user_id: "",
        label: "",
        rate_class: null,
        sub_class: null,
        status: "awaiting_contract_generation",
        address: {
          address: "",
          address_number: "",
          address_complement: "",
          district: "",
          postal_code: "",
          state: {
            name: "",
            initials: "",
          },
          city: "",
          country: {
            name: "Brasil",
            initials: "BR",
          },
        },
        powerplant: {
          power_plant_id: "",
          name: "",
          power_monthly: "",
        },
        history: [
          { mes_ano: "mês 1", consumo: null, dias: 30 },
          { mes_ano: "mês 2", consumo: null, dias: 30 },
          { mes_ano: "mês 3", consumo: null, dias: 30 },
          { mes_ano: "mês 4", consumo: null, dias: 30 },
        ],
        initial_average_comsumption: "",
        contract_id: null,
        cpf: null,
        person_type: null,
        company: null,
        utility_company: null,
      },
      empty_consumerunit: {
        id: "",
        installation_number: "",
        customer_number: "",
        power_plant_id: "",
        percentage: 0,
        percentage_discount: 10,
        fare_amount: 0.95,
        user_id: "",
        label: "",
        rate_class: null,
        sub_class: null,
        status: "awaiting_contract_generation",
        address: {
          address: "",
          address_number: "",
          address_complement: "",
          district: "",
          postal_code: "",
          state: {
            name: "",
            initials: "",
          },
          city: "",
          country: {
            name: "Brasil",
            initials: "BR",
          },
        },
        powerplant: {
          power_plant_id: "",
          name: "",
          power_monthly: "",
        },
        history: [
          { mes_ano: "mês 1", consumo: null, dias: 30 },
          { mes_ano: "mês 2", consumo: null, dias: 30 },
          { mes_ano: "mês 3", consumo: null, dias: 30 },
          { mes_ano: "mês 4", consumo: null, dias: 30 },
        ],
        initial_average_comsumption: "",
        contract_id: null,
        cpf: null,
        person_type: null,
        company: null,
        utility_company: null,
      },
      power_plants: [],
      power_plant: {},
      snack: {
        color: null,
        top: true,
        bottom: false,
        left: false,
        right: false,
        snackMessage: "",
        snackbar: false,
      },
      loading: false,
      consumer_unit_sel: "",
      type: "new",
      valid: false,
      notEmptyRule: [(v) => !!v || "Por favor, esse dado é obrigatório."],
      installationNumberRule: [
        (v) => !!v || "Por favor, esse dado é obrigatório.",
        (v) => {
          switch (this.consumerunit?.utility_company) {
            case "neoenergia-pe":
              if (v.length < 6 || v.length > 7)
                return "O número deve ter 6 ou 7 dígitos";
              break;

            case "neoenergia-ba":
              if (v.length < 6 || v.length > 8)
                return "O número deve ter de 6 a 8 dígitos";
              break;

            case "cpfl-piratininga":
              if (v.substr(0, 1) !== "2" && v.substr(0, 1) !== "4")
                return "O primeiro dígito deve ser 2 ou 4";
              if (v.substr(1, 1) !== "0") return "O segundo dígito deve ser 0";
              if (v.length !== 10) return "O número deve ter 10 dígitos";
              break;

            case "cemig":
              if (v.length !== 10) return "O número deve ter 10 dígitos";
              if (v.substr(0, 3) !== "300" && v.substr(0, 3) !== "301")
                return "O número deve começar com 300 ou 301";
              break;

            default:
              return true;
          }
          return true;
        },
        (v) => /^\d+$/.test(v) || "Deve conter apenas números.",
      ],
      customerNumberRule: [
        (v) => {
          if (!v) return true;
          return !!v || "Por favor, esse dado é obrigatório.";
        },
        (v) => {
          if (!v) return true;
          switch (this.consumerunit?.utility_company) {
            case "neoenergia-pe":
              if (v.length < 7) return "O número deve ter pelo menos 7 dígitos";
              break;

            case "neoenergia-ba":
              if (v.length < 6) return "O número deve ter pelo menos 6 dígitos";
              break;

            case "cpfl-piratininga":
              if (v.substr(0, 1) !== "7") return "O primeiro dígito deve ser 7";
              if (v.length !== 9) return "O número deve ter 9 dígitos";
              break;

            case "cemig":
              if (v.substr(0, 1) !== "7") return "O primeiro dígito deve ser 7";
              if (v.length !== 10) return "O número deve ter 10 dígitos";
              break;

            default:
              return true;
          }
          return true;
        },
        (v) => {
          if (!v) return true;
          /^\d+$/.test(v) || "Deve conter apenas números.";
        },
      ],
      agent_email: null,
      loading_cep: false,
      verify_debits: false,
      verify_rules: true,
      custom_percentage_discount: null,
      custom_percentage_discount_enable: false,
      custom_unique_billing: null,
      custom_unique_billing_enable: false,
      custom_power_plant: null,
      custom_power_plant_enable: false,
      plan: null,
      plansList: [],
      loading_finish_qualification: false,
      loading_init_qualification: false,
      currentQualification: [],
      allow_finish_qualification: false,
      all_readonly: false,
      history_alert_message: null,
      loading_parse_bill: false,
      currentUcId: null,
      customerUploadKey: 0,
    };
  },
  directives: { mask },
  async created() {
    getPowerPlants().then((pps) => {
      pps.docs.map((pp) => {
        this.power_plants.push({ id: pp.id, ...pp.data() });
      });
    });
    if (this.$route.params.id || this.user.id) {
      this.user_id = this.$route.params.id || this.user.id;
      await firestore
        .collection("users")
        .doc(this.user_id)
        .get()
        .then((ret_doc) => {
          this.user = {
            id: ret_doc.id,
            ...ret_doc.data(),
          };
          this.fillFields();
          if (
            ret_doc.data().available_discounts &&
            ret_doc.data().percentage_discount
          ) {
            this.consumerunit.percentage_discount =
              ret_doc.data().percentage_discount;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
    this.agent_email = this.loggedUser.email || null;
    eventBus.$on("consumerunit", async (consumerunit) => {
      this.resetState();
      if (consumerunit?.readonly) {
        this.all_readonly = true;
      }
      if (consumerunit.type === "edit") {
        await this.consumerunit_details(consumerunit.data.installation_number);
        this.consumer_unit_sel = consumerunit.installation_number;
      } else if (consumerunit.type === "new") {
        this.currentUcId = null;
        if (!consumerunit.data.cpf) {
          consumerunit.data.cpf = this.consumerunit.cpf || this.user.cpf;
        }
        if (!consumerunit.data.person_type) {
          consumerunit.data.cpf =
            this.consumerunit.person_type || this.user.person_type || "pf";
        }
        this.consumerunit = {
          ...this.consumerunit,
          ...consumerunit.data,
        };
      }
      this.updatePlans();
      this.type = consumerunit.type;
      if (consumerunit.type !== "calc")
        if (this.$refs["name"]) this.$refs["name"].focus();
    });
  },
  async mounted() {
    if (this.utilityCompanies?.length <= 0) this.getUtilityCompanies();
    if (this.plans?.length <= 0) await this.getAllPlans();
    this.updatePlans();
  },
  watch: {
    plan() {
      this.consumerunit.percentage_discount = this.plan?.discount;
    },

    "consumerunit.person_type"() {
      this.updatePlans();
    },

    "consumerunit.company"() {
      this.updatePlans();
    },

    qualifications() {
      this.currentQualification = this.qualifications.filter(
        (item) => item.consumer_unit === this.consumerunit.installation_number,
      );
    },

    "consumerunit.installation_number"() {
      this.currentQualification = this.qualifications.filter(
        (item) => item.consumer_unit === this.consumerunit.installation_number,
      );
      this.allow_finish_qualification = false;
    },
    "consumerunit.utility_company"() {
      this.updatePlans();
      this.getSubClassByUtility(this.consumerunit.utility_company);
    },
    "consumerunit.history": {
      deep: true,
      handler() {
        this.checkHistoryReliability();
      },
    },
    "consumerunit.sub_class"() {
      if (this.consumerunit.sub_class.value) {
        this.consumerunit.fare_amount = this.consumerunit.sub_class.value;
      }
    },
    "consumerunit.id"() {
      this.customerUploadKey++;
    },
    "user.id"() {
      this.user_id = this.user.id;
    },
  },
  methods: {
    ...mapActions("qualification", ["resetState", "getQualifications"]),
    ...mapActions("sales", ["getSubClassByUtility", "getAllPlans"]),
    ...mapMutations("qualification", ["setQualifications"]),

    ...mapActions("configuration", ["getUtilityCompanies"]),
    validCPFCNPJ(value, type) {
      if (type === "cpf") return validaCPF(value);
      else return validaCNPJ(value);
    },
    async changePlan() {
      const snapshot = await firestore
        .collection("billing")
        .where("consumer_unit", "==", this.consumerunit.id)
        .get();

      const has_pendencies = snapshot.docs.some(
        (doc) =>
          doc.data().status === "parceled" || doc.data().status === "overdue",
      );
      if (has_pendencies)
        return this.showSnack(
          "Não é possível alterar plano de UCs com pendências!",
          "error",
          "top",
        );
      this.$refs.changeUcPlan.showModal(this.plan);
    },
    showSnack(text, color) {
      this.show_snack(text, color, "top");
    },
    updatePlans() {
      let available_plans = this.filteredPlans({
        person_type: this.consumerunit?.person_type,
        company: this.consumerunit?.company,
        utility_company: this.consumerunit?.utility_company,
      });
      if (this.loggedUser) {
        if (
          this.loggedUser?.group?.includes("sales_partner") ||
          this.loggedUser?.group?.includes("sales_partner_management")
        ) {
          available_plans = available_plans.filter(
            (plan) => plan.promotional === false,
          );
        }
      }
      this.plansList = available_plans;

      // Faz um filter para checar os planos em que o tempo de contrato são maiores que o atual, caso a UC possua plano
      const blocked_status = ["activated", "interrupting", "canceling"];
      if (
        this.consumerunit?.plan &&
        blocked_status.includes(this.consumerunit?.status)
      ) {
        let otherPlans = this.plansList.filter(
          (plan) =>
            plan?.contract_time >= this.consumerunit?.plan?.contract_time,
        );
        this.plansList = otherPlans;
      }
      let userPlan;
      if (
        this.user?.plan &&
        this.consumerunit?.person_type == this.user?.person_type &&
        this.consumerunit?.utility_company == this.user?.utility_company
      ) {
        userPlan = this.user?.plan;
      }

      const selectedPlan = this.consumerunit?.plan || userPlan || null;
      this.plan = selectedPlan;
      if (
        this.plan &&
        !this.plansList?.find((item) => item?.id == this.plan?.id)
      ) {
        this.plansList.push(this.plan);
      }
    },
    setUser(user) {
      if (user) {
        this.user = JSON.parse(JSON.stringify(user));
        this.user_id = this.user.id;
      } else {
        this.user = {};
      }
    },
    async consumerunit_details(id) {
      await firestore
        .collection("consumer_units")
        .doc(id)
        .get()
        .then(async (doc) => {
          if (doc.exists) {
            if (!this.user || !this.user.id) {
              let _user = await firestore
                .collection("users")
                .doc(doc.data().user_id)
                .get();
              if (_user.exists) {
                this.user_id = _user.id;
                this.user = {
                  id: _user.id,
                  ..._user.data(),
                };
              }
            }
            let powerplant = {};
            await firestore
              .collection("power_plants")
              .doc(doc.data().power_plant_id)
              .get()
              .then((pp) => {
                powerplant = {
                  id: pp.id,
                  power_plant_id: id,
                  ...pp.data(),
                };
                this.consumerunit = {
                  id: doc.id,
                  ...doc.data(),
                  powerplant,
                };
                this.currentUcId = this.consumerunit.id;
                this.consumerunit.rate_class = this.mapClasse(
                  doc.data()?.rate_class,
                );
                this.consumerunit.sub_class = this.mapSubClasse(
                  doc.data()?.sub_class,
                );
                if (!this.consumerunit?.person_type && this.consumerunit?.cpf) {
                  this.consumerunit.person_type =
                    this.consumerunit.cpf?.length > 11 ? "pj" : "pf";
                } else {
                  this.consumerunit.person_type =
                    this.user?.person_type || "pf";
                }
                if (!this.consumerunit.cpf)
                  this.consumerunit.cpf = this.user.cpf;
                if (!this.consumerunit.company)
                  this.consumerunit.company = "juntos";
                if (
                  this.consumerunit.history !== undefined &&
                  this.consumerunit.history !== null
                ) {
                  const newhistory = this.consumerunit.history.map((data) => {
                    const omitTypename = (key, value) =>
                      key === "__typename" ? undefined : value;
                    return JSON.parse(JSON.stringify(data), omitTypename);
                  });
                  this.consumerunit.history = newhistory;
                } else {
                  this.consumerunit.history = [
                    { mes_ano: "mês 1", consumo: 0, dias: 30 },
                    { mes_ano: "mês 2", consumo: 0, dias: 30 },
                    { mes_ano: "mês 3", consumo: 0, dias: 30 },
                    { mes_ano: "mês 4", consumo: 0, dias: 30 },
                  ];
                }
              })
              .catch((err) => {
                console.error("Erro ao buscar a Planta: ", err);
              });
          }
          this.valid = true;
          this.loading = false;
        })
        .catch((err) => {
          this.valid = true;
          this.loading = false;
          console.error(err);
        });
    },
    minTimeContract(contract_date, ms) {
      if (!contract_date) return true;
      if (typeof contract_date === "string") {
        if (contract_date.split("/").length > 1) {
          if (contract_date.split("/")[0].length > 2) {
            contract_date = moment(contract_date, "YYYY/MM/DD");
          } else contract_date = moment(contract_date, "DD/MM/YYYY");
        }
        return new Date(contract_date);
      } else if (typeof contract_date === "object") {
        if (contract_date._seconds)
          contract_date = new Date(contract_date._seconds * 1000);
        else if (contract_date.seconds)
          contract_date = new Date(contract_date.seconds * 1000);
        else return undefined;
      }
      let start_date = new Date(contract_date).getTime();
      let end_date = new Date().getTime();
      let diff = end_date - start_date;
      if (diff > ms) return true;
      else return false;
    },
    async createContract(user, consumerunit) {
      this.loading = true;
      //checa permissão
      if (this.consumerunit.status === "activated") {
        try {
          const permission = await getPermission(
            "generate_contract",
            this.loggedUser.id,
          );
          console.log(permission);
          if (!permission.data.has_permission) {
            this.show_snack(
              "Usuário sem permissão para realizar essa ação",
              "error",
              "top",
            );
            this.loading = false;
            return false;
          }
        } catch (err) {
          this.show_snack(
            "Falha ao consultar permissão do usuário",
            "error",
            "top",
          );
          console.error("Falha ao consultar permissão", err);
          this.loading = false;
          return false;
        }
      }

      // 172,800,000 = 2 Dias em Milisenconds
      // 900000 = 15 min
      if (
        consumerunit.contract_created_at &&
        !this.minTimeContract(consumerunit.contract_created_at, 900000)
      ) {
        this.loading = false;
        this.show_snack(
          "Contrato atual foi gerado a menos de 15 minutos e não pode ser regerado!",
          "error",
          "top",
        );
        return;
      }
      let data_uc = {
        generateContract: true,
        updated_at: new Date(),
        contract_created_at: firebase.firestore.FieldValue.delete(),
        constract_type: firebase.firestore.FieldValue.delete(),
        contract_url: firebase.firestore.FieldValue.delete(),
        contrato_gerado: firebase.firestore.FieldValue.delete(),
      };
      firestore
        .collection("consumer_units")
        .doc(consumerunit.installation_number)
        .update(data_uc)
        .then(() => {
          if (
            this.isAdmin ||
            this.isSalesManagement ||
            this.isQualityManagement
          ) {
            this.show_snack(
              "Contrato será gerado em background e pode ser visualizado na tela de atendimento!",
              "success",
              "top",
            );
            this.loading = false;
          } else {
            let old_sellers = user.old_sellers || [];
            let data_user = {
              updated_at: new Date(),
              signedcontract_at: new Date().toISOString(),
              signedcontract_by: "SUPER",
              signedcontract_source: this.loggedUser.partner_id,
              signedcontract_partner: this.loggedUser.email,
            };
            if (user.signedcontract_partner) {
              let object = {
                status: user.status,
                signedcontract_at: user.signedcontract_at,
                signedcontract_by: user.signedcontract_by,
                signedcontract_source: user.signedcontract_source,
                signedcontract_partner: user.signedcontract_partner,
              };
              old_sellers.push(object);
              data_user.old_sellers = old_sellers;
            }
            firestore
              .collection("users")
              .doc(user.id)
              .update(data_user)
              .then(() => {
                this.loading = false;
                this.show_snack(
                  "Contrato será gerado em background e pode ser visualizado na tela de atendimento!",
                  "success",
                  "top",
                );
                this.$router.push(
                  "/atendimento/?installation_number=" +
                    consumerunit.installation_number,
                );
              })
              .catch((error) => {
                this.loading = false;
                this.show_snack("Erro ao gerar contrato!", "error", "top");
                console.error(
                  "Erro ao gerar contrato! - Grava usuário" + error,
                );
              });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.show_snack("Erro ao gerar contrato!", "error", "top");
          console.error("Erro ao gerar contrato! - Grava UC" + error);
        });
    },
    async createQualification() {
      this.loading_init_qualification = true;
      if (this.$refs.form.validate()) {
        let consumptionHistory = this.consumerunit.history.reduce(
          (prev, cur) => {
            return prev + cur.consumo;
          },
          0,
        );
        if (consumptionHistory < 1) {
          this.loading = false;
          this.show_snack(
            "Digite o consumo de pelo menos um mês do histórico.",
            "warning",
            "top",
          );
          return;
        }

        let form_data = {
          utility_company: this.consumerunit.utility_company,
          name: this.consumerunit.name,
          address: this.consumerunit.address,
          cpf: this.consumerunit.cpf,
          customer_number: this.consumerunit.customer_number,
          consumer_unit: this.consumerunit.installation_number,
          rate_class: this.consumerunit.rate_class,
          sub_class:
            this.consumerunit.sub_class?.subclass ||
            this.consumerunit.sub_class,
          fare_amount: this.consumerunit.fare_amount,
          history: this.consumerunit.history,
          verify_debits: this.verify_debits,
          verify_rules: this.verify_rules,
        };
        const partner_origin = this.all_readonly ? "SIM" : null;
        await initQualificationByForm(
          this.consumerunit.cpf,
          this.user_id,
          [this.consumerunit.installation_number],
          [this.consumerunit.customer_number],
          "super_manual",
          form_data,
          this.consumerunit.utility_company,
          null,
          this.agent_email,
          partner_origin,
          this.verify_rules,
        )
          .then(async (ret) => {
            if (ret.status === 200) {
              const qualification_ids = ret.data.ids;
              const params = {
                cpf: this.consumerunit.cpf,
                qualification_ids: qualification_ids,
              };
              await this.getQualifications(params);
              this.allow_finish_qualification = true;
            } else {
              this.show_snack("Erro ao iniciar qualificação.", "error", "top");
            }
          })
          .catch((err) => {
            console.error(err);
            this.show_snack("Erro ao iniciar qualificação.", "error", "top");
          });
      } else {
        this.show_snack(
          "Preencha todos os campos obrigatórios.",
          "error",
          "top",
        );
      }
      this.loading_init_qualification = false;
    },
    async endQualification() {
      this.loading_finish_qualification = true;

      let percentage_discount = this.custom_percentage_discount_enable
        ? this.custom_percentage_discount
        : null;
      let unique_billing = this.custom_unique_billing_enable
        ? this.custom_unique_billing
        : null;
      let power_plant = this.custom_power_plant_enable
        ? this.custom_power_plant
        : null;
      const plan = {
        contract_time: this.plan.contract_time,
        id: this.plan.id,
        name: this.plan.name,
        discount: this.plan.discount,
        person_type: this.plan?.person_type,
      };

      let seller = {
        signedcontract_at: new Date().toISOString(),
        signedcontract_by: this.user.signedcontract_by ?? "SUPER",
        signedcontract_source: "enercred",
        signedcontract_partner:
          this.user.signedcontract_partner ?? this.loggedUser.email,
      };

      await finishQualification(
        this.consumerunit.cpf,
        this.user_id,
        [this.currentQualification[0].id],
        percentage_discount,
        unique_billing,
        power_plant,
        plan,
        seller,
        "super_manual",
        this.agent_email,
      )
        .then((ret) => {
          if (ret.status === 200) {
            let result = ret.data.results[ret.data.results.length - 1];
            let uc_added = !result ? false : result.consumer_unit_added;
            if (!uc_added) {
              this.show_snack(
                "Erro ao adicionar Unidade Consumidora! " + result.message,
                "warning",
                "bottom",
              );
            } else {
              this.allow_finish_qualification = false;
              this.show_snack(
                "Unidade Consumidora adicionada com sucesso!",
                "success",
                "bottom",
              );
            }
          } else {
            this.show_snack(
              "Erro ao adicionar Unidade Consumidora! " + ret.data,
              "error",
              "bottom",
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.show_snack(
            `Erro ao adicionar Unidade Consumidora! ${
              err && err.response ? err.response.data : ""
            }`,
            "error",
            "bottom",
          );
        });
      this.loading_finish_qualification = false;
    },
    async storeconsumerunit(user_id, consumerunit) {
      this.loading = true;
      if (this.$refs.form.validate()) {
        if (
          this.type === "new" &&
          (await this.validaUnidadeConsumidora(
            consumerunit.installation_number,
          ))
        ) {
          console.error(
            "Erro: Já possui Unidade Consumidora cadastrada com esse número de instalação",
          );
          this.loading = false;
          return;
        }
        if (consumerunit.percentage <= 0) {
          this.show_snack(
            "Consumo muito baixo. Cliente não está apto a receber créditos de energia.",
            "error",
            "top",
          );
          this.loading = false;
          return;
        }
        let country = { initials: "BR", name: "Brasil" };
        if (
          consumerunit &&
          consumerunit.address &&
          consumerunit.address.country
        ) {
          ((country.initials = consumerunit.address.country.initials),
            (country.name = consumerunit.address.country.name));
        }
        let address = {
          address: "",
          address_number: "",
          address_complement: "",
          district: "",
          postal_code: "",
          state: {
            initials: "",
            name: "",
          },
          city: "",
          country: country,
        };
        if (consumerunit && consumerunit.address) {
          address = {
            address: consumerunit.address.address,
            address_number:
              consumerunit.address.address_number === ""
                ? consumerunit.address.address.replace(/^\D+/g, "")
                : consumerunit.address.address_number,
            address_complement:
              consumerunit.address?.address_complement || null,
            district: consumerunit.address.district,
            postal_code: consumerunit.address.postal_code,
            state: {
              initials: consumerunit.address.state.initials,
              name: consumerunit.address.state.name,
            },
            city: consumerunit.address.city,
            country: country,
          };
        }

        let status = this.consumerunit.status || "awaiting_contract_generation";

        let newUserConsumerUnit = {
          ...consumerunit,
          user_id: user_id,
          address: address,
          status: status,
          doneBy: this.loggedUser.id,
          change: this.motivo,
          sub_class:
            this.consumerunit.sub_class.subclass || this.consumerunit.sub_class,
        };

        const oldConsumerUnitResponse = await getConsumerUnit(this.currentUcId);
        const oldConsumerUnit = oldConsumerUnitResponse.data();

        if (
          oldConsumerUnit &&
          (oldConsumerUnit.percentage_discount !=
            this.consumerunit.percentage_discount ||
            oldConsumerUnit.power_plant_id !==
              this.consumerunit.powerplant.id ||
            oldConsumerUnit.contract_id !== this.consumerunit.contract_id)
        ) {
          newUserConsumerUnit.last_sensitive_change_by = this.loggedUser.id;
          newUserConsumerUnit.last_sensitive_change_at = new Date();
        }

        if (newUserConsumerUnit.history && newUserConsumerUnit.rate_class) {
          try {
            const res = await calcQualification(
              newUserConsumerUnit.percentage_discount,
              newUserConsumerUnit.fare_amount,
              newUserConsumerUnit.rate_class,
              newUserConsumerUnit.history.map((h) => h.consumo),
            );
            newUserConsumerUnit = {
              ...newUserConsumerUnit,
              ...res.data.values,
            };
          } catch (error) {
            console.error(error);
            this.show_snack("Erro ao calcular valores da qualificação", "red");
            this.loading = false;
            return;
          }
        }
        if (this.plan) {
          newUserConsumerUnit.plan = {
            id: this.plan.id,
            name: this.plan.name,
            contract_time: this.plan.contract_time,
            discount: this.plan.discount,
            person_type:
              this.plan?.person_type || newUserConsumerUnit.person_type || null,
          };
        }
        if (this.consumerunit.contract_id) {
          newUserConsumerUnit.contract_id = this.consumerunit.contract_id;
        }
        if (!user_id || user_id === "undefined") {
          this.show_snack("Erro: User não selecionado", "error", "top");
          this.loading = false;
          return;
        }

        let userRef = firestore.collection("users").doc(user_id);
        let _user = await userRef.get();
        if (_user.exists) {
          const coupon = _user.data()?.coupon;
          if (coupon && coupon.power_plant_id) {
            // Coloca a UC na planta definida
            newUserConsumerUnit.power_plant_id = coupon.power_plant_id;
          }
        }

        let exec;
        try {
          if (this.consumerunit.id) {
            if (
              this.type == "edit" &&
              newUserConsumerUnit.installation_number != this.currentUcId
            ) {
              await this.recreateUc(newUserConsumerUnit);
              this.loading = false;
              return;
            } else {
              exec = firestore
                .collection("consumer_units")
                .doc(this.consumerunit.id)
                .update(newUserConsumerUnit);
            }
          }
        } catch (error) {
          console.error(error);
          this.show_snack("Erro ao salvar a Unidade Consumidora", "red");
          this.loading = false;
          return;
        }

        await exec
          .then(async () => {
            if (this.type === "edit" && this.consumer_unit_sel !== "") {
              this.addHistory(
                newUserConsumerUnit,
                "updated",
                this.loggedUser,
                this.motivo,
              );
            }
            if (this.type === "new") {
              if (_user.exists) {
                const coupon = _user.data()?.coupon;
                if (
                  coupon &&
                  coupon.discont &&
                  coupon.discount > 0 &&
                  !coupon.applied
                ) {
                  let user_update = {
                    updated_at: new Date(),
                    account_balance: coupon.discount,
                    coupon: { applied: true },
                  };
                  userRef.update(user_update).catch((err) => {
                    console.error(err);
                    this.show_snack(
                      "Erro ao adicionar cupon no usuário.",
                      "error",
                      "top",
                    );
                  });
                }
              }
              const analytics = {
                eventCategory: "QUALIFICACAO",
                eventAction: "QUALIFICACAO-MANUAL",
                eventLabel: this.loggedUser.email,
                unidade_consumidora: newUserConsumerUnit.id,
                value: newUserConsumerUnit.mensalidade,
                boleto: false,
              };

              saveAnalytics(analytics);
            }

            this.loading = false;
            this.show_snack(
              "Unidade Consumidora gravada com sucesso!",
              "success",
              "top",
            );
          })
          .catch((error) => {
            this.loading = false;
            this.show_snack(
              "Erro ao gravar user. " + error.message,
              "error",
              "top",
            );
          });
      } else {
        this.show_snack(
          "Preencha todos os campos obrigatórios.",
          "error",
          "top",
        );
      }
      this.loading = false;
    },

    async recreateUc(newUserConsumerUnit) {
      //checa permissão
      try {
        const permission = await getPermission(
          "change_uc_id",
          this.loggedUser.id,
        );

        if (!permission.data.has_permission) {
          this.show_snack(
            "Usuário sem permissão para realizar essa ação",
            "error",
            "top",
          );
          return false;
        }
      } catch (err) {
        this.show_snack(
          "Falha ao consultar permissão do usuário",
          "error",
          "top",
        );
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      try {
        // recria UC
        let newUc = {
          ...newUserConsumerUnit,
          id: newUserConsumerUnit.installation_number,
          status: "activated",
          last_agent_id: this.loggedUser?.id,
          last_agent_name: this.loggedUser?.name,
          last_agent_email: this.loggedUser?.email,
          updated_at: new Date(),
          created_at: new Date(),
          allocation_status: "awaiting_powerplant",
          created_after_sale_analysis: true,
          generateContract: true,
        };
        delete newUc?.contract_signed_at;
        delete newUc?.contract_created_at;
        delete newUc?.contract_status;
        delete newUc?.contract_id;
        delete newUc?.contract_url;
        delete newUc?.contrato_gerado;
        delete newUc?.constract_type;
        delete newUc?.activation_info;
        delete newUc?.billing_competence_end;
        delete newUc?.cemig_status;

        try {
          await firestore.collection("consumer_units").doc(newUc.id).set(newUc);
        } catch (error) {
          console.error(error);
          this.show_snack("Erro ao criar UC com id correto.", "error", "top");
          return;
        }

        // busca subcollection balance na uc incorreta
        const balance = await firestore
          .collection("consumer_units")
          .doc(this.currentUcId)
          .collection("balance")
          .get();
        if (balance?.size > 0) {
          let balances = [];
          for (const value of balance.docs) {
            balances.push(value.data());
          }

          for (const value of balances) {
            await firestore
              .collection("consumer_units")
              .doc(newUc.id)
              .collection("balance")
              .add(value);
          }
        }

        // busca account_balance_history na uc incorreta
        const account_balance_history = await firestore
          .collection("consumer_units")
          .doc(this.currentUcId)
          .collection("account_balance_history")
          .get();
        if (account_balance_history?.size > 0) {
          let balances = [];
          for (const value of account_balance_history.docs) {
            balances.push(value.data());
          }

          for (const value of balances) {
            await firestore
              .collection("consumer_units")
              .doc(newUc.id)
              .collection("account_balance_history")
              .add(value);
          }
        }

        // atualiza historico da UC correta
        this.addHistory(newUc, "created", this.loggedUser, this.motivo);

        // cancela uc incorreta
        const fieldsOldUc = {
          status: "canceled",
          forced_canceling: true,
          user_id: firebase.firestore.FieldValue.delete(),
          status_reason: "sale_analysys",
          last_agent_id: this.loggedUser.id,
          last_agent_name: this.loggedUser.name,
          last_agent_email: this.loggedUser.email,
          cancel_agent: this.loggedUser.email,
          canceled_at: new Date(),
          updated_at: new Date(),
          wrongly_registered: true,
        };
        await firestore
          .collection("consumer_units")
          .doc(this.currentUcId)
          .update(fieldsOldUc);

        await this.setQualifications([]);
        this.$emit("getUcs");
        this.$refs.cpfField.focus();
        this.show_snack(
          "Dados da UC alterados e contrato gerado.",
          "green",
          "top",
        );
      } catch (error) {
        console.error(error);
        this.show_snack(
          "Erro no processo de criar UC com id correto.",
          "error",
          "top",
        );
        return;
      }
    },

    setAutoQualification(partner_origin) {
      this.consumerunit = { ...this.auto_qualification };
      this.all_readonly = partner_origin ? true : false;
      this.type = this.consumerunit.type;
      this.currentUcId = this.consumerunit.installation_number;
      this.$refs.ucPlan.focus();
      this.customerUploadKey++;
    },

    buscaCep(cep) {
      if (cep && cep !== "") {
        this.loading_cep = true;
        getCEP(cep)
          .then((result) => {
            ((this.consumerunit.address.address = result.data.logradouro),
              (this.consumerunit.address.district = result.data.bairro));
            this.consumerunit.address.city = result.data.localidade;
            this.consumerunit.address.state = this.states?.find(
              (item) => item.initials === result.data.uf,
            );
            this.loading_cep = false;
          })
          .catch((error) => {
            this.show_snack(
              "Erro ao buscar o CEP informado. Erro: " + error,
              "error",
              "top",
            );
            this.loading_cep = false;
          });
      }
    },
    async validaUnidadeConsumidora(installation_number) {
      if (this.type === "new") {
        return await firestore
          .collection("consumer_units")
          .doc(installation_number)
          .get()
          .then((res) => {
            if (res.exists) {
              this.show_snack(
                "Erro: Unidade Consumidora já cadastrada no sistema",
                "error",
                "top",
              );
              this.loading = false;
              return true;
            }
          })
          .catch(() => {
            return false;
          });
      }
      return false;
    },
    calcAverage(data) {
      let sum = data.reduce(function (sum, value, index) {
        if (value.consumo && value.consumo * 1 > 0 && index < 4) {
          return sum + value.consumo;
        } else {
          return sum;
        }
      }, 0);
      let tam = data.filter((value) => value.consumo * 1 > 0).length;
      if (sum > 0 && tam > 0) {
        let avg = sum / (tam > 4 ? 4 : tam);
        return avg;
      } else return 0;
    },

    calcMediana(data) {
      let values = [];
      data.reduce(function (sum, value) {
        if (value.consumo && value.consumo * 1 > 0) {
          return values.push(value.consumo);
        }
      }, 0);
      values = values.sort();
      let tam = values.length;
      if (tam % 2 == 0) {
        return (values[tam / 2 - 1] + values[tam / 2]) / 2;
      } else {
        tam++;
        return values[tam / 2 - 1];
      }
    },

    calcCustoDisp(classe) {
      if (classe?.toUpperCase().includes("MONOFÁSICO")) return 30;
      if (classe?.toUpperCase().includes("BIFÁSICO")) return 50;
      if (classe?.toUpperCase().includes("TRIFÁSICO")) return 100;
      return 50;
    },

    desvioPadrao(average, data) {
      let values = [];
      let sum = 0;
      data.reduce(function (sum, value) {
        if (value.consumo && value.consumo * 1 > 0) {
          return values.push(value.consumo);
        }
      }, 0);
      values.forEach((value) => {
        sum += (value - average) ** 2;
      });
      return Math.sqrt(sum / values.length);
    },

    calcCreditos(media, custo_disp) {
      return media - custo_disp;
    },
    show_snack(message, color, ...args) {
      this.snack.top = true;
      this.snack.bottom = false;
      this.snack.left = false;
      this.snack.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },
    addHistory(consumerunit, action, user, motivo) {
      const history = {
        created_at: new Date(),
        user_id: user.id,
        email: user.email,
        action: action,
        status: consumerunit.status,
        obs: motivo,
      };
      firestore
        .collection("consumer_units")
        .doc(consumerunit.id)
        .collection("history")
        .add(history);
    },
    fillFields() {
      ((this.consumerunit.name = this?.user?.name),
        (this.consumerunit.cpf = this?.user?.cpf));
      this.consumerunit.company = this?.user?.company || null;
    },
    preventNumberChange(event) {
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    },
    checkHistoryReliability() {
      this.history_alert_message = null;
      const history = JSON.parse(
        JSON.stringify(this.consumerunit.history),
      )?.slice(0, 4);
      const consumo = history?.map((item) => item.consumo);
      const orderedConsumo = consumo?.sort((a, b) => b - a);
      const division = orderedConsumo[0] / orderedConsumo[1];

      if (orderedConsumo[2] == "" || orderedConsumo[2] == null) {
        return;
      }

      if (orderedConsumo[0] >= 20000) {
        this.history_alert_message =
          "Atenção! Histórico com consumo muito alto. Por favor, verifique se os dados estão corretos.";
        return;
      }

      if (division >= 5) {
        this.history_alert_message =
          "Atenção! Variação muito grande de consumo. Por favor, verifique se os dados estão corretos.";
        return;
      }
    },
    mapClasse(value) {
      const _value = value.toLowerCase();
      if (_value.includes("monofásico")) return "Monofásico";
      if (_value.includes("bifásico")) return "Bifásico";
      if (_value.includes("trifásico")) return "Trifásico";
      return value;
    },

    mapSubClasse(value) {
      if (!value) return null;
      const _value = value.toLowerCase();
      const subclass = this.subclasses?.find((item) => (item.subclass = value));
      if (subclass) return subclass;
      if (_value.includes("comercial")) return "Comercial";
      if (_value.includes("residencial")) return "Residencial";
      return value;
    },

    clearForm() {
      this.consumerunit = JSON.parse(JSON.stringify(this.empty_consumerunit));
    },
  },
  computed: {
    ...mapState("qualification", ["auto_qualification"]),
    ...mapState("configuration", ["utilityCompanies"]),
    ...mapGetters("qualification", ["qualifications", "getQualificationsIds"]),
    ...mapGetters("sales", ["plansByUtilityCompany", "filteredPlans"]),
    ...mapState("sales", ["subclasses", "plans"]),
    ...mapGetters(["loggedUser"]),
    ...mapState(["permissions"]),

    isAdmin() {
      let currentUserGroups = this.loggedUser.group.toString();
      return currentUserGroups.indexOf("admin") >= 0;
    },

    isSalesManagement() {
      let currentUserGroups = this.loggedUser.group.toString();
      return currentUserGroups.indexOf("sales_management") >= 0;
    },

    isQualityManagement() {
      let currentUserGroups = this.loggedUser.group.toString();
      return currentUserGroups.indexOf("quality_management") >= 0;
    },

    qualification_ids() {
      return this.getQualificationsIds ?? [];
    },

    customer_number_formatted() {
      if (this.consumerunit.utility_company == "neoenergia-pe") {
        return "Código do Cliente";
      } else if (this.consumerunit.utility_company == "cpfl-piratininga") {
        return "Conta Contrato";
      }
      return "Número do Cliente";
    },
  },

  deactivated() {
    this.resetState();
  },
  destroyed() {
    this.resetState();
  },
};
</script>
<style scoped lang="scss">
.history_alert {
  color: #eb8e02;
  .icon {
    transform: translateY(2px);
  }
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.icon_position {
  position: absolute;
  transform: translate(-25px, -5px) !important;
  background: #fff !important;
  padding: 6px;
}
</style>
